import React, { useEffect, useState } from 'react';
import { LinearProgress, Box } from '@mui/material';

interface ProgressBarProps {
    done: boolean;
    delayMs?: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ done, delayMs = 100 }) => {
    const [progress, setProgress] = useState(0);
    const [buffer, setBuffer] = useState(0);

    useEffect(() => {
        if (!!done) {
            return;
        }

        const getRandomDelay = () => {
            const min = Math.max(100, delayMs - 100);
            const max = delayMs + 100;
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        let timeoutId: NodeJS.Timeout;

        const updateProgress = () => {
            setProgress((oldProgress) => {
                if (oldProgress >= 99) {
                    return 99;
                }
                return Math.min(oldProgress + 1, 99);
            });
            setBuffer((oldBuffer) => {
                if (oldBuffer >= 99) {
                    return 99;
                }
                return Math.min(oldBuffer + 1, 99);
            });

            timeoutId = setTimeout(updateProgress, getRandomDelay());
        };

        timeoutId = setTimeout(updateProgress, getRandomDelay());

        return () => {
            clearTimeout(timeoutId);
        };
    }, [done, delayMs]);

    useEffect(() => {
        if (done) {
            setProgress(100);
            setBuffer(100);
        }
    }, [done]);

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <LinearProgress 
                variant="buffer" 
                value={progress} 
                valueBuffer={buffer}
                sx={{
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    '& .MuiLinearProgress-bar1Buffer': {
                        borderRadius: 5,
                        backgroundColor: '#1976d2',
                    },
                    '& .MuiLinearProgress-bar2Buffer': {
                        borderRadius: 5,
                        backgroundColor: 'rgba(25, 118, 210, 0.2)',
                    }
                }}
            />
            {/* <Typography 
                variant="body2" 
                sx={{ 
                    position: 'absolute', 
                    right: 0, 
                    top: -20,
                    color: done ? '#4caf50' : '#1976d2'
                }}
            >
                {done ? 'Complete' : `${Math.round(progress)}%`}
            </Typography> */}
        </Box>
    );
}; 